import { z } from 'zod';

/**
 * Free medical treatment type create/update form schema.
 * Used for validation in FreeMedicalTreatmentTypeEditModal.
 * Aligned with backend FreeMedicalTreatmentTypeStoreRequest / UpdateRequest.
 */
export const freeMedicalTreatmentTypeSchema = z.object({
  free_medical_treatment_category_id: z
    .number({ required_error: 'カテゴリ名は必要です', invalid_type_error: 'カテゴリ名は必要です' })
    .int()
    .positive('カテゴリ名は必要です'),
  service_type: z.enum(['A2', 'R2', 'BOTH'], {
    required_error: 'サービスは必要です',
    invalid_type_error: 'サービスは必要です',
  }),
  name: z
    .string()
    .trim()
    .min(1, '自由診療名は必要です')
    .max(255, 'メニュー名は255文字以下にしてください。'),
  price: z
    .number({ required_error: '金額は必要です', invalid_type_error: '金額は必要です' })
    .int('金額は整数で入力してください。')
    .min(0, '金額は0以上で入力してください。')
    .max(9999999999, '金額は10桁以下で入力してください。'),
  required_time: z.number().int().positive().nullable().optional(),
  default_flag: z.boolean(),
});

export type TreatmentTypeFormSchema = z.infer<typeof freeMedicalTreatmentTypeSchema>;
